/**
 * Whether a typed address is one the API will take.
 *
 * The pattern is Zod's own email rule, the one every schema's `.email()` runs
 * on the server, so a form can refuse exactly what the server would refuse —
 * before a round trip, and in a sentence rather than a validation dump. The web
 * app does not load Zod, so the pattern is carried here, and an API test holds
 * it equal to Zod's: the two cannot drift apart without a failing test.
 */
export const EMAIL_PATTERN =
  /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9-]*\.)+[A-Za-z]{2,}$/

export function isEmailAddress(value: string): boolean {
  return EMAIL_PATTERN.test(value.trim())
}

/** What a form says when an address is not one yet. */
export const EMAIL_PROBLEM =
  'Enter a full email address, like name@example.com.'
